import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Clipboard } from '../../core/clipboard/clipboard.model';

@Component({
    selector: 'app-clipboard-data-dialog',
    templateUrl: './clipboard-data-dialog.component.html',
    styles: [
        /* language=SCSS */
        `
            .clipboard-data-dialog-panel {

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClipboardDataDialogComponent {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
           clipboardItem: Clipboard,
        },
        public dialogRef: MatDialogRef<ClipboardDataDialogComponent>,
    ) { }

    closeDialog() {
        this.dialogRef.close();
    }

}
